<template>
  <section class="section">
    <LazyBg :src="bgSrc" />
    <div class="section-dim" aria-hidden="true" />
    <div class="container">
      <h2 class="section-title">公司简介</h2>
      <p class="section-lead">立足国产化 AI 战略机遇，打造算力硬件 + 软件平台 + 场景应用的全栈能力</p>

      <div class="about-intro">
        <p>
          海曦技术（HYXINO）核心团队汇聚人工智能、芯片研发、行业应用等领域资深专家。立足国产化 AI 战略发展机遇，聚焦多行业数字化转型需求，以“自主可控、安全可信”为核心研发导向，构建从底层技术到场景落地的全链条 AI 能力体系，致力于打破国外技术壁垒，推动中国 AI 产业自主可控发展。
        </p>
        <p>
          以国产化 AI 芯片适配为核心底座，打造“算力硬件 + 软件平台 + 场景应用”三位一体产品矩阵，为政务、医疗、工业、青少年心理等关键行业，提供全栈式、可定制的智能解决方案。深耕医疗、教育、青少年心理健康等核心赛道，同步拓展金融、电商等泛行业场景；全面服务政府单位、央企国企、中小企业，累计服务客户超 100 家，项目落地全国 20 余个省市。
        </p>
      </div>

      <div class="features-grid">
        <div v-for="f in highlights" :key="f.title" class="feature-card">
          <div class="feature-icon" v-html="f.icon" />
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>

      <p class="about-mission">
        以“让 AI 与人为善，与人类为善”为使命；持续深化产学研合作，共建国产化 AI 生态，成为国内领先的场景化 AI 解决方案提供商，助力千行百业实现数字化、智能化转型。
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import LazyBg from '@/components/LazyBg.vue';
import bgSrc from '@/assets/about_bg_company.png';

const highlights = [
  {
    title: '自主可控',
    desc: '核心技术 100% 自主研发，拥有 30+ 项发明专利与软件著作权，国产化 AI 芯片适配、多模态算法、隐私计算均通过权威认证，全链路无国外技术依赖。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
  },
  {
    title: '技术闭环',
    desc: '构建“芯片适配 → 算力支撑 → 模型研发 → 场景落地”完整技术闭环，解决行业客户技术碎片化、适配不兼容等核心痛点。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>'
  },
  {
    title: '场景落地',
    desc: '沉淀医疗 AI 辅助诊断、工业智能质检、青少年心理筛查等标杆案例，标准化方案 + 定制化服务交付，平均交付周期缩短 30%，客户满意度超 95%。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 12l2 2 4-4"/><path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"/></svg>'
  }
];
</script>

<style scoped lang="scss">
.section-dim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.45));
  pointer-events: none;
}

.container {
  position: relative;
  z-index: 2;
}

.about-intro {
  max-width: 900px;
  margin: 40px auto 0;
  text-align: center;

  p {
    margin: 0 0 16px;
    font-size: 15px;
    line-height: 1.75;
    color: #fff;
    opacity: 0.75;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.about-mission {
  margin: 48px auto 0;
  max-width: 860px;
  text-align: center;
  font-size: 16px;
  line-height: 1.7;
  color: #fff;
  opacity: 0.85;
  padding: 28px 32px;
  border-radius: 8px;
  border: 1px solid rgba(239, 239, 239, 0.2);
  background: linear-gradient(180deg, rgba(28, 32, 41, 0.5) 0%, rgba(28, 32, 41, 0) 100%);
}
</style>
